
export class LunchCountsContext {
    constructor() {

    }
}
